














import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class BaseButton extends Vue {
  @Prop() href: string
  @Prop({ type: Boolean, default: false }) disabled: boolean
  @Prop({ type: Boolean }) inline: boolean;
  @Prop({ type: Boolean, default: false }) small: boolean
  @Prop({ default: 'none' }) position: string;
  @Prop({ type: Boolean, default: false }) loading!: boolean;
  @Prop() variant: ButtonVariant
  @Prop() type: string // disabled, primary, success, warning, danger

  handleClick (e: MouseEvent) {
    e.stopPropagation()
    this.$emit('click')
  }
}
